export default __webpack_public_path__ + "static/media/Yellow dot button.7b0a345e.svg";